import { useState, useEffect } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d5oeclfecauet1j8belg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString(),
      });

      if (response.ok) {
        form.reset();
        alert('¡Gracias! Nos pondremos en contacto contigo pronto. También puedes escribirnos a perforacionesacuiferasdelorien@gmail.com');
        setShowModal(false);
      }
    } catch (error) {
      alert('Hubo un error. Por favor, intenta nuevamente o escríbenos a perforacionesacuiferasdelorien@gmail.com');
    }
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14 sm:h-20">
            <div className="flex items-center gap-2">
              <img 
                src="https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/f46d6d7fdf1212c6ac5407b2a6c22460.jpeg" 
                alt="Perforaciones Acuíferas del Oriente" 
                className="h-8 w-8 sm:h-14 sm:w-14 object-contain rounded-full"
              />
              <span className={`font-bold text-[10px] sm:text-sm md:text-lg transition-colors leading-tight ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                <span className="hidden sm:inline">Perforaciones Acuíferas del Oriente</span>
                <span className="sm:hidden">Perf. Acuíferas<br/>del Oriente</span>
              </span>
            </div>
            <button 
              onClick={() => setShowModal(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 sm:px-6 sm:py-3 rounded-lg font-semibold text-xs sm:text-base transition-all whitespace-nowrap cursor-pointer"
            >
              Cotizar
            </button>
          </div>
        </div>
      </nav>

      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/a7f91b9585417b3780eb8d2ab69d7b35.png"
            alt="Perforaciones Acuíferas del Oriente"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full py-20 sm:py-20 mt-8 sm:mt-0">
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            💧 Perforaciones de Pozos de Agua Profesionales
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl text-white/95 mb-6 sm:mb-10 max-w-4xl mx-auto leading-relaxed">
            Soluciones confiables en perforaciones acuíferas, estudios geofísicos y sistemas de agua.
          </p>
          <div className="flex flex-col gap-3 justify-center items-center">
            <a 
              href="https://wa.me/51994719367?text=Hola,%20necesito%20información%20sobre%20perforación%20de%20pozos"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-5 py-3 sm:px-8 sm:py-4 rounded-lg font-bold text-sm sm:text-lg transition-all shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2 w-full sm:w-auto justify-center max-w-xs sm:max-w-none"
            >
              <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
              +51 994 719 367
            </a>
            <a 
              href="https://wa.me/51953183017?text=Hola,%20necesito%20información%20sobre%20perforación%20de%20pozos"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-5 py-3 sm:px-8 sm:py-4 rounded-lg font-bold text-sm sm:text-lg transition-all shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2 w-full sm:w-auto justify-center max-w-xs sm:max-w-none"
            >
              <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
              +51 953 183 017
            </a>
            <button 
              onClick={() => setShowModal(true)}
              className="bg-white hover:bg-gray-100 text-blue-600 px-5 py-3 sm:px-8 sm:py-4 rounded-lg font-bold text-sm sm:text-lg transition-all shadow-lg whitespace-nowrap cursor-pointer w-full sm:w-auto max-w-xs sm:max-w-none"
            >
              Solicitar Información
            </button>
          </div>
        </div>

        <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-2xl sm:text-4xl text-white"></i>
        </div>
      </section>

      {showModal && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-3 sm:p-4">
          <div className="bg-white rounded-xl max-w-md w-full p-5 sm:p-8 relative max-h-[90vh] overflow-y-auto">
            <button 
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">Solicitar Cotización</h3>
            <form id="cotizacion-form" data-readdy-form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
              <div>
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5">Nombre completo</label>
                <input 
                  type="text" 
                  name="nombre"
                  required
                  className="w-full px-3 py-2.5 sm:px-4 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="Tu nombre"
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5">Correo electrónico</label>
                <input 
                  type="email" 
                  name="email"
                  required
                  className="w-full px-3 py-2.5 sm:px-4 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="tu@email.com"
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5">Teléfono</label>
                <input 
                  type="tel" 
                  name="telefono"
                  required
                  className="w-full px-3 py-2.5 sm:px-4 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="+51 999 999 999"
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5">Tipo de servicio</label>
                <select 
                  name="servicio"
                  required
                  className="w-full px-3 py-2.5 sm:px-4 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm cursor-pointer"
                >
                  <option value="">Selecciona un servicio</option>
                  <option value="Perforación de pozos">Perforación de pozos</option>
                  <option value="Estudios geofísicos">Estudios geofísicos</option>
                  <option value="Limpieza y mantenimiento">Limpieza y mantenimiento</option>
                  <option value="Instalación de bombas">Instalación de bombas</option>
                  <option value="Sistemas de abastecimiento">Sistemas de abastecimiento</option>
                  <option value="Asesoría técnica">Asesoría técnica</option>
                </select>
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5">Mensaje</label>
                <textarea 
                  name="mensaje"
                  rows={3}
                  maxLength={500}
                  className="w-full px-3 py-2.5 sm:px-4 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="Cuéntanos sobre tu proyecto..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
              </div>
              <button 
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold transition-all cursor-pointer whitespace-nowrap text-sm sm:text-base"
              >
                Enviar Solicitud
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
